import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Database, MapPin, MessageCircle, Trophy } from 'lucide-react';
import Hero from '../components/ui/Hero';
import CTASection from '../components/home/CTASection';
import ScrollReveal from '../components/ui/ScrollReveal';
import PageTransition from '../components/ui/PageTransition';
import InteractiveButton from '../components/ui/InteractiveButton';

const HomePage = () => {
  const navigate = useNavigate();
  const heroImage = "https://nifmkzddenyukgjcdetc.supabase.co/storage/v1/object/public/animatronics_data/logo_light.webp";

  return (
    <PageTransition>
      <Hero
        title="Discover the World of Animatronics"
        description="Explore our growing database of animatronics from theme parks and attractions worldwide."
        backgroundImage={heroImage}
      >
        <div className="flex flex-col sm:flex-row gap-6 justify-center max-w-4xl mx-auto w-full px-4">
          {/* Database Button */}
          <button
            onClick={() => navigate('/database')}
            className="relative overflow-hidden rounded-xl group flex-1 aspect-[2/1] sm:aspect-[3/2] flex items-center justify-center transition-transform hover:scale-[1.02]"
          >
            {/* Background Image */}
            <div className="absolute inset-0 bg-gradient-to-br from-black/70 via-black/50 to-black/70 group-hover:from-black/60 group-hover:to-black/60 transition-all z-10" />
            <div 
              className="absolute inset-0 bg-cover bg-center"
              style={{ backgroundImage: 'url(https://res.cloudinary.com/dqmcjhu1l/image/upload/v1741123155/Collage_Animatroncis_ugcoxt.webp)' }}
            />
            
            {/* Content Box */}
            <div className="relative z-20 bg-brand/20 backdrop-blur-sm border border-brand/30 rounded-lg p-6 m-4 transition-all group-hover:bg-brand/30">
              <Database className="w-8 h-8 mb-3 mx-auto text-brand group-hover:scale-110 transition-transform" />
              <h3 className="text-xl sm:text-2xl font-bold text-white">Explore the Database</h3>
            </div>
          </button>

          {/* Map Button */}
          <button
            onClick={() => navigate('/map')}
            className="relative overflow-hidden rounded-xl group flex-1 aspect-[2/1] sm:aspect-[3/2] flex items-center justify-center transition-transform hover:scale-[1.02]"
          >
            {/* Background Image */}
            <div className="absolute inset-0 bg-gradient-to-br from-black/70 via-black/50 to-black/70 group-hover:from-black/60 group-hover:to-black/60 transition-all z-10" />
            <div 
              className="absolute inset-0 bg-cover bg-center"
              style={{ backgroundImage: 'url(https://res.cloudinary.com/dqmcjhu1l/image/upload/v1741121772/Map_pqkddo.webp)' }}
            />
            
            {/* Content Box */}
            <div className="relative z-20 bg-brand/20 backdrop-blur-sm border border-brand/30 rounded-lg p-6 m-4 transition-all group-hover:bg-brand/30">
              <MapPin className="w-8 h-8 mb-3 mx-auto text-brand group-hover:scale-110 transition-transform" />
              <h3 className="text-xl sm:text-2xl font-bold text-white">View the Map</h3>
            </div>
          </button>
        </div>
      </Hero>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-16">
        <ScrollReveal>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <CTASection
              title="Join the Community Discussion"
              description="Connect with fellow enthusiasts, share knowledge, and discuss your favorite animatronics in our growing community forum."
              icon={MessageCircle}
              buttonText="Visit the Forum"
              buttonLink="/community/forum"
              imageUrl="/images/automata-history.webp"
            />
            <CTASection
              title="Vote for Your Favorites"
              description="Help us rank the world's most impressive animatronics. Cast your votes in head-to-head matchups and see how your favorites stack up."
              icon={Trophy}
              buttonText="Start Ranking"
              buttonLink="/ranking-game"
              imageUrl="/images/film-animatronics.webp"
            />
          </div>
        </ScrollReveal>
      </div>
    </PageTransition>
  );
};

export default HomePage;